
const selectHeaderDomain = () => (state) => state.header;

export {
  selectHeaderDomain,
};

